import gql from 'graphql-tag'

export default gql`
  query getStoresByLocation($locationToSearch: StoreLocationSearch) {
    getStoresByLocation(locationToSearch: $locationToSearch) {
      stores {
        storeId
        merchantId
        name
        coordinate {
          latitude
          longitude
        }
        phone {
          country_code
          national_number
        }
        distance
        address {
          line1
          line2
          city
          state
          postalCode
          country
        }
      }
      locationAddress
    }
  }
`
